<div class="wrapper">

    <div class="left-panel-width-hack" *ngIf="showLeftPanel"></div>

    <div fxLayout="row" fxLayoutGap="20px">
        <div fxFlex="{{ hideGeneralPanel ? 100 : 70}}" fxFlex.lt-md="100">
            <module-content *ngIf="session" [title]="session.name ?? ''">
                <div *ngIf="!isEditable" class="session-share {{ session.libraryId === null ? 'topmarged' : null}}">
                    <app-chat-share [organization]="organization" [sharable]="session">
                        <button mat-mini-fab [matTooltip]="'Share' | translate" tabindex="-1">
                            <mat-icon>share</mat-icon>
                        </button>
                    </app-chat-share>
                  <button *ngIf="!session.libraryId && library"
                            mat-mini-fab
                            tabindex="-1"
                            [disabled]="isWorking"
                            [matTooltip]="'Save_to_library' | translate"
                            (click)="onClickSaveToLibrary(sessionRow!)">
                        <mat-icon class="up">book</mat-icon>
                    </button>
                    <!--<button mat-mini-fab aria-label="Expand more"
                            [matTooltip]="'Open_all' | translate"
                            (click)="onToggleAllClicked(false)">
                        <mat-icon class="up">expand_more</mat-icon>
                    </button>
                    <button mat-mini-fab aria-label="Expand less"
                            [matTooltip]="'Collapse_all' | translate"
                            (click)="onToggleAllClicked(true)">
                        <mat-icon class="down">expand_less</mat-icon>
                    </button>-->
                </div>
            </module-content>
        </div>
    </div>
<div fxLayout="row" [class.hidden]="!hideGeneralPanel">
        <div fxFlex="100" *ngIf="sessionRow">
            <sessions-session-general-panel [organization]="organization"
                                            [isEditable]="false"
                                            [(session)]="sessionRow"
                                            [(sessionItems)]="sessionItems"
                                            [simpleColumn]="false">
            </sessions-session-general-panel>
        </div>
    </div>
    <div fxLayout="row" [class.hidden]="!hideGeneralPanel">
        <div fxFlex="100" *ngIf="session && session.comment">
            <div class="summary popup">
                <div class="label">{{ 'generalComment' | translate }}</div>
                <div class="value">{{ session.comment }}</div>
            </div>
        </div>
    </div>

    <div fxLayout="row-reverse" fxLayout.lt-md="column" fxLayoutGap="20px">
        <div fxFlex="30" [class.hidden]="hideGeneralPanel">
            <div class="session-aside-panel mat-elevation-z1">
                <div class="session-general">
                    <div class="title">{{ 'general' | translate }}</div>
                    <div class="row" *ngIf="session">
                        <div class="summary">
                            <div class="label">{{ 'sessionTitle' | translate }}</div>
                            <div class="value">{{ session.name }}</div>
                        </div>

                        <div class="main-comment"></div>
                    </div>
                    <div class="row" *ngIf="session && session.comment">
                        <div class="summary">
                            <div class="label">{{ 'generalComment' | translate }}</div>
                            <div class="value">{{ session.comment }}</div>
                        </div>
                    </div>
                    <div class="row" *ngIf="session && session.tags">
                        <div class="summary">
                            <div class="label">{{ 'Tags' | translate }}</div>
                            <div class="value">{{ session.tags }}</div>
                        </div>
                    </div>
                </div>
                <sessions-session-general-panel [class.hidden]="hideGeneralPanel"
                                                [organization]="organization"
                                                [isEditable]="false"
                                                [(session)]="sessionRow!"
                                                [(sessionItems)]="sessionItems">
                    <main-action *ngIf="!isMobileDisplay && sessionRow && sessionRow.rights?.edit"
                                 mainAction
                                 [title]="'Edit_session' | translate"
                                 [icon]="'edit'"
                                 (onAction)="onEditClicked()">
                    </main-action>
                </sessions-session-general-panel>
            </div>
        </div>

        <div fxFlex="{{ hideGeneralPanel ? 100 : 70}}">
            <div class="session-items-container">
                <div *ngFor="let item of sessionItems">
                    <session-bloc *ngIf="item.type === 'BLOC'"
                                  [blocNumber]="getBlocNumber(item)"
                                  [data]="item"
                                  [organization]="organization"
                                  [isMobileDisplay]="isMobileDisplay"
                                  [isEditable]="isEditable">
                    </session-bloc>
                    <session-comment *ngIf="item.type === 'COMMENT'"
                                     [data]="item"
                                     [isEditable]="isEditable">
                    </session-comment>
                    <session-rest *ngIf="item.type === 'REST'"
                                  [data]="item"
                                  [isEditable]="isEditable">
                    </session-rest>
                </div>
            </div>
        </div>
    </div>
</div>
